/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTSVG} from '../../../helpers'

type Props = {
  className: string
  color: string
  svgIcon: string
  iconColor: string
  title: string
  description: string
}

const StatisticsWidget5: React.FC<Props> = ({
  className,
  color,
  svgIcon,
  iconColor,
  title,
  description,
}) => {
  return (
    <span className={`card bg-${color} ${className}`}>
      {/* begin::Body */}
      <div className='card-body d-flex align-items-end mx-auto'>
        <KTSVG path={svgIcon} className={`svg-icon-${iconColor} svg-icon-3x ms-n1 mx-5`} />

        <div className={`text-inverse-${color} fw-bolder fs-2`}>{title}</div>

        <div className={`fw-bold text-inverse-${color} fs-7 mx-2 mb-2`}>{description}</div>
      </div>
      {/* end::Body */}
    </span>
  )
}

export {StatisticsWidget5}
